// extracted by mini-css-extract-plugin
export default {"section_header":"PageHeader_section_header__pHZMa","main_header":"PageHeader_main_header__rIwfL"};